exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*$vs-colors: (\n        lightest: rgba(60, 60, 60, 0.26),\n        light: rgba(60, 60, 60, 0.5),\n        dark: #333,\n        darkest: rgba(0, 0, 0, .15),\n) !default;*/\n.become-member-form .v-select {\n  box-shadow: none;\n}\n.become-member-form .vs__dropdown-toggle {\n  padding: 0 0 16px 16px;\n}\n.become-member-form .vs__search,\n.become-member-form .vs__search:focus {\n  margin: 16px 0 0 0;\n}\n.become-member-form .vs__dropdown-option {\n  padding: 8px 16px;\n}\n.become-member-form .vs__selected {\n  margin: 16px 0 0 0;\n}\n.become-member-form .vs__actions {\n  padding: 16px 16px 0 16px;\n}", ""]);

// exports
